import { vars } from '@repo/config';
import type { IClientConfig, TypeCredentialsMode } from './create-client-config';
import { createClientConfig } from './create-client-config';

let clientConfig: IClientConfig | null = null;

export function initializeClient(config: {
  baseUrl: string;
  defaultHeaders?: Record<string, string>;
  headerProvider?: () => Record<string, string> | Promise<Record<string, string>>;
  onUnauthorized?: () => Promise<Record<string, string> | null>;
  onError?: (error: Error) => void;
  timeout?: number;
  credentials?: TypeCredentialsMode;
}): void {
  clientConfig = createClientConfig(config);
}

export function getClientConfig(): IClientConfig {
  if (!clientConfig) {
    clientConfig = createClientConfig({ baseUrl: vars.url.apiUrl });
  }
  return clientConfig;
}
